import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import { SmartButton } from '../../common/SmartButton';
import PropTypes from 'prop-types';

import * as bookActions from '../../../actions/bookActions';
import * as revealActions from '../../../actions/revealActions';
import Reveal from '../../common/reveal/Reveal';
import HeaderReveal from '../../common/reveal/HeaderReveal';
import AssignedClassrooms from './AssignedClassrooms';
import { Text } from './DesynchronizeComponents';
import * as bookApi from '../../../services/api/bookApi';

export const DESYNCHRONIZE_ACTIVITY_REVEAL = 'desynchronizeActivityReveal';

export class DesynchronizeActivityReveal extends React.Component {
  static propTypes = {
    revealActions: PropTypes.object,
    desynchronizeActivity: PropTypes.func,
    setDesynchronizeActivityContext: PropTypes.func,
    activeClassrooms: PropTypes.array,
    desynchronizeActivityContext: PropTypes.object,
    classroom: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = { linkedClassrooms: [] };
    this.closeReveal = this.closeReveal.bind(this);
    this.handleDesyncActivity = this.handleDesyncActivity.bind(this);
  }

  componentDidMount() {
    this.loadLinkedClassrooms();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.desynchronizeActivityContext !== this.props.desynchronizeActivityContext) {
      this.loadLinkedClassrooms();
    }
  }

  loadLinkedClassrooms() {
    const { desynchronizeActivityContext, classroom } = this.props;
    if (!desynchronizeActivityContext?.activityId || !classroom?.sectionId) {
      return;
    }
    bookApi
      .getLinkedClassroomsForActivity(desynchronizeActivityContext.activityId, classroom.sectionId)
      .then(res => {
        const data = res && res.data;
        const linkedClassrooms = Array.isArray(data) ? data : data && Array.isArray(data.data) ? data.data : [];
        this.setState({ linkedClassrooms });
      })
      .catch(() => this.setState({ linkedClassrooms: [] }));
  }

  closeReveal() {
    this.props.setDesynchronizeActivityContext(null);
    this.props.revealActions.setOpenReveal();
  }

  handleDesyncActivity() {
    const { desynchronizeActivityContext, desynchronizeActivity } = this.props;
    if (!desynchronizeActivityContext) {
      return;
    }
    const { classroomId, activityId, bookId } = desynchronizeActivityContext;
    desynchronizeActivity(classroomId, activityId, bookId);
  }

  renderContent() {
    const { activeClassrooms } = this.props;
    const { linkedClassrooms } = this.state;
    return (
      <div className="desynchronize-book-reveal-container">
        <div className="info-text">{I18n.t('bookContainer.desynchronizeInfo1')}</div>
        <AssignedClassrooms synchronizedClassrooms={linkedClassrooms} activeClassrooms={activeClassrooms} />
        <div className="info-text">
          <Text>{I18n.t('bookContainer.desynchronizeInfo2')}</Text>
          <Text>{I18n.t('bookContainer.desynchronizeInfo3')}</Text>
          <Text>{I18n.t('bookContainer.desynchronizeInfo5')}</Text>
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.desynchronizeActivityContext) {
      return null;
    }

    return (
      <Reveal id={DESYNCHRONIZE_ACTIVITY_REVEAL} className="red">
        <HeaderReveal title={I18n.t('bookContainer.desynchronizeContent')} onCloseOnClick={this.closeReveal} />

        <div className="content">{this.renderContent()}</div>

        <div className="footer">
          <SmartButton onClick={this.closeReveal}>{I18n.t('common.cancel')}</SmartButton>
          <SmartButton danger onClick={this.handleDesyncActivity}>
            {I18n.t('bookContainer.desynchronize')}
          </SmartButton>
        </div>
      </Reveal>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DesynchronizeActivityReveal);

function mapStateToProps(state) {
  return {
    classroom: state.classrooms.selectedClassroom.classroom,
    activeClassrooms: state.classrooms.activeClassrooms,
    desynchronizeActivityContext: state.book.desynchronizeActivityContext
  };
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch),
    desynchronizeActivity: bindActionCreators(bookActions.desynchronizeActivity, dispatch),
    setDesynchronizeActivityContext: bindActionCreators(bookActions.setDesynchronizeActivityContext, dispatch)
  };
}
